import React, {Component} from 'react';
import {ExibeLocalizacaoCorpo} from './ExibeLocalizacaoCorpo';

export class ExibeLocalizacao extends Component {
    constructor(props) {
        super(props)
        this.state = {
          currentLatLng: {
            lat: 0,
            lng: 0
          },
        }
      }

    erroLocalizacao(){
        alert("Não foi possível obter a localização, por favor, apontar manualmente.");
    }

    render() {
        return (
            <div>
                <ExibeLocalizacaoCorpo id={this.props.match.params.id} currentLocation={this.state.currentLatLng}/>
            </div>
        );
    }
}